import {__} from "./__";

export const getComplaintStatuses = () => {
    return {
        waiting: __('Prijatá'),
        processing: __('Spracováva sa'),
        sent: __('Odoslaná'),
        ready_for_pickup: __('Pripravená na prevzatie'),
        processed: __('Vybavená'),
        aborted: __('Zamietnutá'),
    };
};
